"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var catalog_service_1 = require("../../../utils/catalog-service");
/**
 * Simple remote key-value storage interface. Use-case: persist some data
 * on back-end per site-basis.
 * @doc PrivateSettings
 * @extends CatalogService
 */
var PrivateSettings = /** @class */ (function (_super) {
    tslib_1.__extends(PrivateSettings, _super);
    function PrivateSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get settings
     * @param {AxiosRequestConfig} requestConfig
     * @returns {AxiosPromise<Settings>}
     * @example
     *
     * const settings = await new PrivateSettings()
     *  .get()
     *  .then(response => response.data);
     */
    PrivateSettings.prototype.get = function (requestConfig) {
        return this.axiosInstance.get('/catalog/settings', requestConfig);
    };
    /**
     * Either create new or update existing settings
     * @param {Settings} settings
     * @param {AxiosRequestConfig} requestConfig
     * @returns {AxiosPromise<Settings>}
     * @example
     *
     * const updatedSettings = await new PrivateSettings()
     *  .update({settingName: true})
     *  .then(response => response.data);
     */
    PrivateSettings.prototype.update = function (settings, requestConfig) {
        return this.axiosInstance.post('/catalog/settings', settings, requestConfig);
    };
    /**
     * Reset settings
     * @param {AxiosRequestConfig} requestConfig
     * @returns {AxiosPromise}
     * @example
     *
     * const service = new PrivateSettings();
     * await service.reset();
     *
     * const settings = await service
     *  .get()
     *  .then(response => response.data);
     *
     * Object.keys(settings).length === 0 // true
     */
    PrivateSettings.prototype.reset = function (requestConfig) {
        return this.axiosInstance.delete('/catalog/settings', requestConfig);
    };
    return PrivateSettings;
}(catalog_service_1.CatalogService));
exports.PrivateSettings = PrivateSettings;
//# sourceMappingURL=settings.js.map